import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import WashingtonFranchise from "@/pages/franchise/WashingtonFranchise";

export const Route = createFileRoute("/_public/franchise/washington")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Washington Fence Franchise \u2014 Territory In Play | Modern Fence Install", "Washington is open for a Modern Fence Install franchise \u2014 currently in talks with an operator. $16.5k\u2013$20k all-in including first-job materials. Add $100k\u2013$200k to your service business.", "/franchise/washington", true),
  component: WashingtonFranchise,
});
